import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminDashboard from './pages/AdminDashboard';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import AdminOrders from './pages/AdminOrders';
import AdminProducts from './pages/AdminProducts';
import AdminRevenue from './pages/AdminRevenue';
import AdminUsers from './pages/AdminUsers';
import AdminStats from './pages/AdminStats';
import ProductPage   from './pages/ProductPage'
import GroupPage from "./pages/GroupPage";
import CartPage from "./pages/CartPage";
import OrderConfirmation from "./pages/OrderConfirmation"
import ProfilePage from './pages/ProfilePage';
import AdminInbox from './pages/AdminInbox';
import TermsPage from "./pages/TermsPage";
import PrivacyPolicy from './pages/PrivacyPolicy';
import ContactPage from './pages/ContactPage';
import BoderStatic from './pages/BoderStatic';
import Checklist from './pages/Checklist';
import Kjopsvilkar from "./pages/Kjopsvilkar";
import QuizPage from "./pages/QuizPage";
import QuizResults from "./pages/QuizResults";
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VippsReturn from './pages/VippsReturn';


function App() {
  const user = null; // kan evt settes fra AuthContext

  return (
    <Layout user={user}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route path="/group/:id" element={<GroupPage />} />      
        <Route path="/order-confirmation/:id" element={<OrderConfirmation />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/boder" element={<BoderStatic />} />
        <Route path="/checklist" element={<Checklist />} />
        <Route path="/kjopsvilkar" element={<Kjopsvilkar />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/quiz-results" element={<QuizResults />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password"  element={<ResetPassword />} />
        <Route path="/vipps/return" element={<VippsReturn />} />

        <Route element={<ProtectedRoute />}>
        <Route path="/cart" element={<CartPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        </Route>
        

        {/* Beskyttede adminruter */}
        <Route element={<ProtectedRoute adminOnly />}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/revenue" element={<AdminRevenue />} />
          <Route path="/admin/stats" element={<AdminStats />} />
          <Route path="/admin/inbox" element={<AdminInbox />} />
        </Route>

        {/* Fallback? */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </Layout>
  );
}

export default App;
